import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'
import {
  AbsoluteFillStyle,
  CenterizedContentStyle,
  RelativeContainerStyle,
} from 'theme'

const CenterizedStyle = css`
  ${CenterizedContentStyle};
`

const PlaceholderContainer = styled.div`
  background-color: ${({ theme }) => theme.color.grey07};
  border: 1px solid ${({ theme }) => theme.color.grey10};
  border-radius: ${({ theme }) => theme.space.s4};
  ${RelativeContainerStyle};
`

const Placeholder = styled.div`
  ${AbsoluteFillStyle};
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space.s16};
  ${({ centerizedContent }) => centerizedContent && CenterizedStyle};
`
function VideoPlaceholder({ children, centerizedContent }) {
  return (
    <PlaceholderContainer>
      <Placeholder centerizedContent={centerizedContent}>
        {children}
      </Placeholder>
    </PlaceholderContainer>
  )
}

VideoPlaceholder.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  centerizedContent: PropTypes.bool,
}

VideoPlaceholder.defaultProps = {
  children: undefined,
  centerizedContent: true,
}
export default VideoPlaceholder
